import React from 'react';
import { Box } from '@mui/material';
import BugReportIcon from '@mui/icons-material/BugReport';
import ReviewsIcon from '@mui/icons-material/Reviews';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { FeedbackType } from 'features/feedback/shared/feedback.types';

const META: Record<FeedbackType, { icon: React.ReactNode; color: string; bg: string }> = {
  BUG: { icon: <BugReportIcon sx={{ fontSize: 17 }} />, color: '#E2330A', bg: 'rgba(226,51,10,.10)' },
  REVIEW: { icon: <ReviewsIcon sx={{ fontSize: 17 }} />, color: '#3B2C93', bg: 'rgba(59,44,147,.10)' },
  IDEA: { icon: <LightbulbIcon sx={{ fontSize: 17 }} />, color: '#12a596', bg: 'rgba(39,204,188,.14)' },
};

const TypeBadge: React.FC<{ type: FeedbackType }> = ({ type }) => {
  const m = META[type];
  return (
    <Box
      sx={{
        width: 28, height: 28, borderRadius: '8px', flex: '0 0 auto',
        display: 'grid', placeItems: 'center', background: m.bg, color: m.color,
      }}
    >
      {m.icon}
    </Box>
  );
};

export default TypeBadge;
